<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    this.itemLink = `business/clients/${this.id}/groups`;
    this.setLink = `business/clients/${this.id}/groups`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "client_group",
      fields: [
        {
          col: "col-12 col-md-6",
          label: "Выберите группу",
          key: "group",
          type: "select",
          selectKey: "title",
          modal: "group",
          prefix: "client_group",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_group",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "title",
          title: "Класс",
          checkbox: false,
        },
        {
          key: "locale",
          title: "Локализация класса",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "join_at",
          title: "Зачислен",
          checkbox: false,
          dateTimeFormat: true,
        },
        {
          key: "left_at",
          title: "Выбыл",
          checkbox: false,
          dateTimeFormat: true,
        },
        {
          detail: false,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
